import { render, staticRenderFns } from "./AggregateViews.vue?vue&type=template&id=1894b1cc&"
import script from "./AggregateViews.vue?vue&type=script&lang=js&"
export * from "./AggregateViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports